<template>
	 <div class="auth" id="auth" name="auth">
		<div class="auth-content">
			<!-- 左边图片 -->
			<div class="contentLeft"></div>
			<!-- 左边图片 end -->
			<!-- 右边内容 -->
			<div class="contentRight">
				<!-- 表单部分 -->
				<div class="mi-layout__container">
					<div class="card">
						<ul class="tab-tilte">
							<li @click="switchTab(0)" :class="cur == 0 ? 'active' : '' ">登录</li>
							<li @click="switchTab(1)" :class="cur == 1 ? 'active' : '' ">注册</li>
						</ul>
						<!-- 登录 -->
						<div class="tab_input"  v-if="cur == 0">
							<form method="post" class="tab_form2">
								<p class="signIn_Num"><input type="text" placeholder="手机号" v-model="LoginUser.phone"></p>
								<p class="signIn_password"><input v-model="LoginUser.code" type="text" placeholder="请输入验证码" ><span class="codeBtn" type="text" :disabled="countdown > 0" @click="sendCode">{{ countdown > 0 ? `${countdown} 秒后获取` : '获取验证码' }}</span></p>
								<el-checkbox v-model="isChecked" style="margin-top: 20px;"><span style="color: #bbb;">已阅读并同意 <el-button type="text" class="user_agreement" @click="showDialog('用户协议')">用户协议</el-button> 和 <el-button type="text" class="user_agreement" @click="showDialog('隐私政策')">隐私政策</el-button></span></el-checkbox>
								<el-button type="primary" class="signIn" @click="Login">登录</el-button>
							</form>
						</div>
						<!-- 注册 -->
						<div class="tab_input" style="text-align: center;" v-if="cur == 1">
							<div class="biankuang" style="margin-top: 40px;" @click="showDialog('注册个人账号')">
								<div>注册个人账号</div>
							</div>
							<div class="biankuang" style="margin-top: 20px;" @click="showDialog('注册商家账号')">
								<div>注册商家账号</div>
							</div>
							<!-- <p style="margin-top: 20px;color: #bbb;"><a href="#" class="user_agreement">用户协议</a> 和 <a href="#" class="user_agreement">隐私政策</a></p> -->
						</div>
					</div>
				</div>
				<!-- 表单部分 end -->
			</div>
			<!-- 右边内容 end -->
		</div>
		<el-dialog :title="dialogTitle" :width="dialogTitle == '用户协议' || dialogTitle == '隐私政策'  ? '800px' : '380px'" center :visible.sync="isShowDialog">
			<div v-if="dialogTitle == '用户协议' || dialogTitle == '隐私政策'">
				<vue-markdown :source="md"></vue-markdown>
			</div>
			<div v-else>
				<el-form :model="LoginUser"  status-icon ref="ruleForm" class="demo-ruleForm">
				  <div v-if="dialogTitle == '注册商家账号'">
					<p style="margin-bottom: 10px;font-size: 17px;color: #409eff;">商家资料</p>
					  <el-form-item prop="companyName">
						<el-input placeholder="请输入公司名称" v-model="BusUser.companyName"></el-input>
					  </el-form-item>
					  <el-form-item prop="responsibleName">
						<el-input placeholder="请输入负责人姓名" v-model="BusUser.responsibleName"></el-input>
					  </el-form-item>
					  <el-form-item prop="responsibleName">
					  	<el-input placeholder="请输入负责人手机号" v-model="BusUser.concat"></el-input>
					  </el-form-item>
					  <el-form-item prop="companyAddress">
						<el-input placeholder="请输入联系地址" v-model="BusUser.companyAddress"></el-input>
					  </el-form-item>
					  <el-form-item label="公司营业执照">
					  	<el-upload
					  	  class="avatar-uploader"
					  	  :data="uploadData"
					  	  action="/api/minio/upload"
					  	  :show-file-list="false"
					  	  :on-success="handleAvatarSuccess"
					  	  :before-upload="beforeAvatarUpload">
					  	  <img v-if="BusUser.license" :src="BusUser.license" class="avatar">
					  	  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					  	</el-upload>
					  </el-form-item>
				  </div>
				  <p style="margin-bottom: 10px;font-size: 17px;color: #409eff;">账号信息</p>
				  <el-form-item prop="name">
				    <el-input placeholder="手机号码" v-model="LoginUser.phone">
				     <!-- <el-button slot="append"  @click="sendCode" type="primary">发送</el-button> -->
					 <el-button slot="append" :disabled="countdown > 0" @click="sendCode">{{ countdown > 0 ? `${countdown} 秒后获取` : '获取验证码' }}</el-button>
				    </el-input>
				  </el-form-item>
				  <el-form-item prop="pass">
				    <el-input type="password" placeholder="请输入验证码" v-model="LoginUser.code"></el-input>
				  </el-form-item>
				  
				  <el-form-item>
				    <el-button size="medium" type="primary" @click="Login" style="width:100%;">{{dialogTitle}}</el-button>
				  </el-form-item>
				</el-form>
				<el-checkbox v-model="isChecked" style="margin-top: 20px;"><span style="color: #bbb;">已阅读并同意 <el-button type="text" class="user_agreement" @click="showDialog('用户协议')">用户协议</el-button> 和 <el-button type="text" class="user_agreement" @click="showDialog('隐私政策')">隐私政策</el-button></span></el-checkbox>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import VueMarkdown from "vue-markdown";

export default {
  name: "MyLogin",
  components: {
    VueMarkdown
  },
  data() {
    // 用户名的校验方法
    let validateName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号码"));
      }
      // 用户名以字母开头,长度在5-16之间,允许字母数字下划线
      const userNameRule = /^1[3-9]\d{9}$/;
      if (userNameRule.test(value)) {
        this.$refs.ruleForm.validateField("checkPass");
        return callback();
      } else {
        return callback(new Error("手机号码格式错误"));
      }
    };
    // 密码的校验方法
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入密码"));
      }
      // 密码以字母开头,长度在6-18之间,允许字母数字和下划线
      const passwordRule = /^[a-zA-Z]\w{5,17}$/;
      if (passwordRule.test(value)) {
        this.$refs.ruleForm.validateField("checkPass");
        return callback();
      } else {
        return callback(
          new Error("字母开头,长度6-18之间,允许字母数字和下划线")
        );
      }
    };
    return {
		uploadData:{
			bucketName:'license'
		},
      LoginUser: {
        phone: "",
        code: ""
      },
	  BusUser: {
		companyName:"",
		responsibleName:"",
		concat:"",
		companyAddress:"",
		license:""
	  },
	  cur: 0 ,//默认选中第一个tab
	  isChecked:true,		//是否同意协议和隐私
	  dialogTitle:"",		//弹窗标题
	  isShowDialog:false,	//显示弹窗与否
	  md: "",				//markdown文档
	  countdown: 0, 		// 倒计时剩余时间（单位为秒）
	  timerId: null 		// 定时器ID
    };
  },
  computed: {
    // 获取vuex中的showLogin，控制登录组件是否显示
    isLogin: {
      get() {
        return this.$store.getters.getShowLogin;
      },
      set(val) {
        // this.$refs["ruleForm"].resetFields();
        this.setShowLogin(val);
      }
    }
  },
  methods: {
    ...mapActions(["setUser", "setShowLogin"]),
	//登录注册切换
	switchTab(t){
		this.cur=t
	},
    Login() {
		//如果是注册商家账号，判断
		if(this.cur == 1 && this.dialogTitle == "注册商家账号"){
			this.businessRegister()
			return
		}
		const authData = {}
		if(this.LoginUser.phone == "" || this.LoginUser.phone.length != 11){
			this.notifyError("手机号格式错误");
			return
		}else if(this.LoginUser.code == "" || this.LoginUser.code.length != 6){
			this.notifyError("验证码格式错误");
			return
		}else if(this.isChecked == false){
			this.notifyError("请阅读并同意 用户协议 和 隐私政策");
			return
		}
		authData.phone = this.LoginUser.phone
		authData.code = this.LoginUser.code
		
		this.$axios.post("/api/auth/login", authData).then(res => {
			if (res.data.code == "200" || res.data.code == 200) {
				// 隐藏登录组件
				this.isLogin = false;
				// 登录信息存到本地
				let user = JSON.stringify(res.data.data.userDTO);
				let token = res.data.data.token;
				localStorage.setItem("user", user);
				localStorage.setItem("token", token);
				// 登录信息存到vuex
				this.setUser(res.data.data.userDTO);
				// 弹出通知框提示登录成功信息
				this.notifySucceed(res.data.msg);
				// 重定向到首页
				this.$router.replace('/');
				this.isShowDialog = false
			} else {
				// 清空输入框的校验状态
				// this.$refs["ruleForm"].resetFields();
				// 弹出通知框提示登录失败信息
				this.notifyError(res.data.msg);
			  }
		}).catch(err => {
			return Promise.reject(err);
		});
    },
    sendCode:function(){
		if(this.countdown > 0){
			return
		}
		if(this.LoginUser.phone == "" || this.LoginUser.phone.length != 11){
			this.notifyError("手机号格式错误");
			return
		}else if(this.isChecked == false){
			this.notifyError("请阅读并同意 用户协议 和 隐私政策");
			return
		}
		
		this.$axios.post("/api/user/auth/sendVerificationCode", {
			phone: this.LoginUser.phone,
        }).then(res => {
			// “001”代表登录成功，其他的均为失败
			if (res.data.code == "200") {
				this.notifySucceed('发送成功！');
				this.countdown = 60; // 设置初始倒计时时间为60秒
				// 使用setInterval函数每1秒更新倒计时剩余时间并判断是否结束
				this.timerId = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--;
					} else {
						clearInterval(this.timerId); // 清除定时器
					}
			  }, 1000)
			} else{
				this.notifyError('发送失败！');
			}
		}).catch(err => {
			return Promise.reject(err);
		});
    },
	showDialog(value){
		this.dialogTitle = value
		this.isShowDialog = true
		if(value == '用户协议' || value == '隐私政策'){
			let title = ''
			if(value == '用户协议'){
				title = "AccountAgreement"
			}else if(value == '隐私政策'){
				title = "PrivacyAgreement"
			}
			this.$axios.post("/api/md",{
				title:title,
			}).then(res => {
				this.md = res.data;
			}).catch(err => {
				// return Promise.reject(err);
				this.md = "请求失败，请刷新页面重试"
			});
		}
	},
	businessRegister(){
		
		const authData = {}
		if(this.LoginUser.phone == "" || this.LoginUser.phone.length != 11){
			this.notifyError("手机号格式错误");
			return
		}else if(this.LoginUser.code == "" || this.LoginUser.code.length != 6){
			this.notifyError("验证码格式错误");
			return
		}else if(this.isChecked == false){
			this.notifyError("请阅读并同意 用户协议 和 隐私政策");
			return
		}else if(this.BusUser.companyName == ""){
			this.notifyError("请输入公司名称");
			return
		}else if(this.BusUser.responsibleName == ""){
			this.notifyError("请输入负责人姓名");
			return
		}else if(this.BusUser.concat == ""){
			this.notifyError("请输入负责人手机号");
			return
		}else if(this.BusUser.companyAddress == ""){
			this.notifyError("请输入联系地址");
			return
		}else if(this.BusUser.license == ""){
			this.notifyError("请上传营业执照");
			return
		}
		authData.phone = this.LoginUser.phone
		authData.code = this.LoginUser.code
		authData.responsibleName = this.BusUser.responsibleName
		authData.companyName = this.BusUser.companyName
		authData.companyAddress = this.BusUser.companyAddress
		authData.concat = this.BusUser.concat
		authData.license = this.BusUser.license
		
		this.$axios.post("/api/user/businessesRegistered", authData).then(res => {
			if (res.data.code == "200" || res.data.code == 200) {
				// 隐藏登录组件
				this.isLogin = false;
				// 登录信息存到本地
				let user = JSON.stringify(res.data.data.userDTO);
				let token = res.data.data.token;
				localStorage.setItem("user", user);
				localStorage.setItem("token", token);
				// 登录信息存到vuex
				this.setUser(res.data.data.userDTO);
				// 弹出通知框提示登录成功信息
				this.notifySucceed(res.data.msg);
				// 重定向到首页
				// this.$router.replace('/');
				this.isShowDialog = false
				this.$alert('审核通过后可获得商家权益', '注册成功', {
				  confirmButtonText: '确定',
				  callback: action => {
					// 重定向到首页
					this.$router.replace('/');
				  }
				});
			} else {
				// 清空输入框的校验状态
				// this.$refs["ruleForm"].resetFields();
				// 弹出通知框提示登录失败信息
				this.notifyError(res.data.msg);
			  }
		}).catch(err => {
			return Promise.reject(err);
		});
		
	},
	beforeAvatarUpload(file){
		const houzhui = ['image/jpeg','image/png','image/bmp','image/webp','image/jpg']
		const isJPG = houzhui.includes(file.type);
		const isLt2M = file.size / 1024 / 1024 < 2;
			
		if (!isJPG) {
		  this.$message.error('上传头像图片只能是 JPG 格式!');
		}
		if (!isLt2M) {
		  this.$message.error('上传头像图片大小不能超过 2MB!');
		}
		return isJPG && isLt2M;
	},
	handleAvatarSuccess(res, file){
		this.BusUser.license = res.data.url;
	},
  }
};
</script>

<style scoped>
	.auth {
	  background-color: #f5f5f5;
	}
	.auth .auth-content {
	  width: 1225px;
	  margin: 0 auto;
	  background-color: #fff;
	  display: flex;
	}
	.contentLeft{
	    width: 25%;
		height: 70vh;
		background-image: url(https://cdn.web-global.fds.api.mi-img.com/mcfe--mi-account/static/static/media/banner.92c693b4..jpg);
		background-size: 100%;
	}
	.contentRight{
	    overflow: hidden;
	    flex: 1;
	}
	  
	/* 表单部分 */
	.mi-layout__container{
	    /* text-align: center; */
	    padding-top: 20px;
	}
	.card{
	    width: 360px;
	    border-radius: 4px;
	    box-shadow: 0 20px 50px 0 hsl(0deg 0% 64% / 10%);
	    margin: 0 auto 80px;
	    padding: 40px 45px;
	    position: relative;
	    background-color: #fff;
	}
	/* tab切换 */
	.tab-tilte{
	    text-align: left;
	}
	.tab-tilte>li{
	    display: inline;
	    font-size: 22px;
	    color: #bbb;
	    margin-right: 20px;
	}
	.tab-tilte .active{
	    font-weight:bold;
	    color: #333;
	    border-bottom: 3px solid #ff5c00;
	    text-shadow: 0 0 .25px currentColor;
	}
	.tab_input{
	    padding: 20px 2px 0;
	    margin: 0 auto;
	    
	}
	.tab_form>p>span{
	    color: #bbb;
	}
	.user_agreement{
	    text-decoration: none;
	    color: #333;
	}
	.tab_form>p>input{
	    border: 0px;
	    padding: 20px 10px;
	    background: #f9f9f9;
	}
	.tab_form>p{
	    margin-top: 20px;
	}
	.biankuang{
		border: 1px #ff5c00 solid;
		padding: 20px 40px;
		text-align: center;
	}
	/* .phoneNum>input,
	.password>input{
	    padding:20px 10px;
	    width: 334px;
	    outline: none;
	}
	 
	.phoneNum>input::-webkit-input-placeholder,
	.password>input::-webkit-input-placeholder{
	    color: rgba(0,0,0,.4);
	    font-size: 17px;
	    height: 20px;
	    line-height: 20px;
	    top: 20px;
	}
	.submit{
	    background-color: #ff5c00;
	    border: none;
	    color: #fff;
	    border-radius: 4px;
	    padding: 0 20px;
	    opacity: .4;
	    margin-top: 20px;
	    margin-bottom: 10px;
	    width: 374px;
	    font-size: 18px;
	    height: 60px;
	    line-height: 60px;
	} */
	/* 注册 */
	.tab_form2>p input{
	    border: none;
	}
	.signIn_Num,
	.signIn_password{
	    background: #f9f9f9;
	    margin-top: 20px;
	    padding: 20px 10px;
	    width: 334px;
	    height: 20px;
	    line-height: 20px;
	}
	
	.signIn_Num input{
	    background-color: #f9f9f9;
	    font-size: 17px;
	    /* margin-left: 40px; */
	    outline:none;
	    color: rgba(0,0,0,.4);
	    border: none;
	}
	.signIn_password input{
	    font-size: 17px;
	    outline: none;/*点击后无边框*/
	    background-color: #f9f9f9;
	    color: rgba(0,0,0,.4);
	    border: none;
	}
	.signIn_password .codeBtn{
	    margin-right: 0;
	    color: #ff5c00;
	    margin-left: 30px;
	}
	.signIn{
	    background-color: #ff5c00;
	    border: none;
	    color: #fff;
	    border-radius: 4px;
	    padding: 0 20px;
	    margin-top: 20px;
	    margin-bottom: 10px;
	    width: 374px;
	    font-size: 18px;
	    height: 60px;
	    line-height: 60px;
	}
	/* 上传营业执照 */
	.avatar-uploader  {
	    border: 1px dashed #a1a1a1;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
		text-align: center;
		width: 100px;
		height: 100px;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #a1a1a1;
	    width: 100px;
	    height: 100px;
	    line-height: 100px;
	    text-align: center;
	  }
	  .avatar {
	    width: 100px;
	    height: 100px;
	    display: block;
	  }
</style>